exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".route_btn {\n  border-radius: 0;\n  color: #16a359; }\n  .route_btn.active {\n    background-color: #e6e6e6; }\n  .route_btn.inactive {\n    background-color: #ffffff; }\n\n.header_flex {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex: 0 0 65px;\n      flex: 0 0 65px;\n  -ms-flex-preferred-size: 48px;\n      flex-basis: 48px;\n  background: #fafafa;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.07);\n  border-bottom: 1px solid var(--theme-border-color, rgba(0, 0, 0, 0.07)); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/layout/header-nav/header-nav.component.scss
// module id = ../../../../../src/app/components/layout/header-nav/header-nav.component.scss
// module chunks = main